import mnb from '@music/mnb';

export { isInNEMusic } from '@music/mnb';

mnb.addMethod({
    name: 'onPageAppear',
    schema: 'page.didAppear',
});

mnb.addMethod({
    name: 'subscribeNotification',
    schema: 'notification.on',
});

mnb.addMethod({
    name: 'open',
    schema: 'navigator.openURL',
});

mnb.addMethod({
    name: 'close',
    schema: 'navigator.pop',
});

mnb.addMethod({
    name: 'setUI',
    schema: 'page.setUI',
});

mnb.addMethod({
    name: 'fileSelectImage',
    schema: 'file.image',
    query: ['ratio', 'isFullScreen', 'isGifCrop'],
});

mnb.addMethod({
    name: 'fileSelectVideo',
    schema: 'file.video',
    query: ['radio', 'duration', 'isCustomCover', 'isFullScreen', 'minDuration'],
    keepLive: true,
});

mnb.addMethod({
    name: 'fileSelectMultiimage',
    schema: 'file.multiimage',
    query: ['ratio', 'count'],
});

mnb.addMethod({
    name: 'fileSelectFinish',
    schema: 'file.finish',
    query: ['success', 'message'],
});

mnb.addMethod({
    name: 'getStartupSetting',
    schema: 'startup.get',
});

mnb.addMethod({
    name: 'setStartupSetting',
    schema: 'startup.set',
    query: ['data'],
});

mnb.addMethod({
    name: 'songImport',
    schema: 'music.song.import',
    query: ['importUrl', 'scriptUrl'],
});

mnb.addMethod({
    name: 'qrCode',
    schema: 'image.qrcode',
});

mnb.addMethod({
    name: 'playlistTaskImport',
    schema: 'nm.song.importTask',
});

mnb.addMethod({
    schema: 'html.video.play',
    name: 'playvideo',
});

mnb.addClass({
    schema: 'nm.fileDownload',
    name: 'createFileDownloader',
    methods: [
        {
            schema: 'downloadWithPath', name: 'download',
        },
        {
            schema: 'checkExist', name: 'checkExist',
        },
        {
            // 释放下载实例，会引起客户端删除未完成的临时文件
            schema: 'destroy', name: 'destroy',
        },
    ],
});

// Ios端带redirect的登录方法
// https://music-league.hz.netease.com/jsbridge/common/protocol/240
mnb.addMethod({
    schema: 'user.login2',
    name: 'loginIos',
});

mnb.addMethod({
    schema: 'log.add',
    name: 'logger',
});

export default mnb;
